var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.53297 0.890192L3.75859 6.69071C3.5373 6.91314 3.17901 6.91286 2.95801 6.69014L0.0828227 3.79524C-0.0276076 3.68395 -0.0276076 3.50309 0.0828227 3.3918L0.483543 2.98865C0.593973 2.87737 0.773405 2.87737 0.883978 2.98865L3.16544 5.28583C3.27587 5.39712 3.4553 5.39712 3.56588 5.28583L8.73253 0.0834656C8.84296 -0.0278219 9.02239 -0.0278219 9.13296 0.0834656L9.5334 0.486615C9.64411 0.598331 9.64383 0.778905 9.53297 0.890192ZM13.9183 0.486757L13.5237 0.0836084C13.4149 -0.027679 13.238 -0.027679 13.1292 0.0836084L8.03823 5.28583C7.92909 5.39712 7.75251 5.39712 7.64337 5.28583L7.23522 4.86868C7.12636 4.75739 6.94979 4.75711 6.84064 4.8684L6.44549 5.27097C6.33635 5.38226 6.33606 5.56312 6.44521 5.67469L7.43908 6.69C7.65665 6.91271 8.00994 6.913 8.2278 6.69057L13.9177 0.890049C14.0273 0.778905 14.0273 0.598045 13.9183 0.486757Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayLight);
export default __webpack_public_path__ + "static/media/gray_light.583300576a56632c06f0943fd7a82dd0.svg";
export { ForwardRef as ReactComponent };